import React from 'react'
import styled from 'styled-components'
import { Body } from 'src/Styles/text-styles'
import EventSender from 'src/Utils/EventSender'
import { theme } from 'src/Styles/theme'

const Container = styled.div``

const BoldBody = styled(Body)`
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 0.5px;
  @media (max-width: 768px) {
    margin-top: 8px;
  }

  @media (min-width: 768px) {
    margin-top 16px;
  }
`

const SourceLink = styled(Body)`
  position: relative;
  line-height: 1.5;
  letter-spacing: 0.5px;
  color: ${theme.colors.primary};
  padding: 2px 0;

  &::before {
    content: '';
    position: absolute;
    top: 2px; // equal to your padding-top
    bottom: 2px; // equal to your padding-bottom
    left: 0;
    right: 0;
    cursor: pointer;
  }
`
const onLinkTapped = (url: string) => {
  if (localStorage.getItem('isNativeApp')) {
    const event = {
      externalUrl: url,
    }
    try {
      EventSender(JSON.stringify(event))
    } catch (e) {
      //doNothing
    }
  } else {
    window.open(url, '_blank')
  }
}

const firstSourceUrl =
  'https://www.highspeedinternet.com/resources/the-consumers-guide-to-internet-speed'
const secondSourceUrl =
  'https://www.allconnect.com/blog/internet-speed-classifications-what-is-fast-internet'

const SourceView = () => {
  const handleKeyPress = React.useCallback(
    (url: string, event: React.KeyboardEvent) => {
      // Enter or Space key
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        onLinkTapped(url)
      }
    },
    []
  )

  return (
    <Container>
      <Body>
        <BoldBody>Source</BoldBody>
        <SourceLink
          role={'link'}
          tabIndex={0}
          onKeyPress={(event) => handleKeyPress(firstSourceUrl, event)}
          style={{ textDecorationLine: 'underline' }}
          onClick={() => onLinkTapped(firstSourceUrl)}
        >
          {firstSourceUrl}
        </SourceLink>
        <SourceLink
          role={'link'}
          tabIndex={0}
          onKeyPress={(event) => handleKeyPress(secondSourceUrl, event)}
          style={{ textDecorationLine: 'underline' }}
          onClick={() => onLinkTapped(secondSourceUrl)}
        >
          {secondSourceUrl}
        </SourceLink>
      </Body>
    </Container>
  )
}

export default SourceView
